export default {
  'moduleTitle.address': 'Adrese',
  'moduleTitle.address_details': 'Adrese',
  'moduleTitle.activity_details': 'Aktivitātes apraksts',
  'moduleTitle.add_log': 'Pievienot ierakstu',
  'moduleTitle.award_level': 'Līmenis',
  'moduleTitle.adventurous_journey': 'Piedzīvojumu ceļojums',
  'moduleTitle.already_assessed': 'Jau novērtēts!',
  'moduleTitle.approved': 'Apstiprināts!',
  'moduleTitle.assessor_details': 'Ziņas par novērtētāju',
  'moduleTitle.authorising_contact_license_holder': 'Pilnvarotā kontakpersona',
  'moduleTitle.category_journey_details': '{category} Informācija par ceļojumu',
  'moduleTitle.complete_report': 'Pabeigt pārskatu',
  'moduleTitle.completed_progress': 'Pabeigts {finished} / {total}',
  'moduleTitle.congratulation': 'Apsveicam!',
  'moduleTitle.confirming_email_address': 'Apstiprināt e-pasta adresi ...',
  'moduleTitle.contact_details': 'Kontakinformācija',
  'moduleTitle.edit_log': 'Labot ierakstu',
  'moduleTitle.event_journey': 'Ceļojums',
  'moduleTitle.forgotten_password': 'Aizmirsu paroli',
  'moduleTitle.great_you_are_almost_there': 'Privātuma politika',
  'moduleTitle.home_address': 'Dzīvesvietas adrese',
  'moduleTitle.journey_overview': 'Ceļojuma pārskats',
  'moduleTitle.log_detail': 'Ieraksta detaļas',
  'moduleTitle.login': 'Ielogoties',
  'moduleTitle.new_activity': 'Jauna aktivitāte',
  'moduleTitle.new_event_journey': 'Jauns {event} ceļojums',
  'moduleTitle.new_residential_project': 'Jauns projekts',
  'moduleTitle.notRegistred': 'Neesi reģistrējies?',
  'moduleTitle.nominated_award_leader_contact_details': 'Award vadītāja kontaktinformācija',
  'moduleTitle.nominated_award_leader': 'Award koordinators',
  'moduleTitle.organisation_address': 'Iestādes / organiāzijas adrese',
  'moduleTitle.organisation_details': 'Informācija par iestādi / organizāciju',
  'moduleTitle.online_record_book_account': 'Tiešsaistes sasniegumu grāmatas konts',
  'moduleTitle.page_not_found': '404 - lapa netika atrasta',
  'moduleTitle.personal_details': 'Tavi dati',
  'moduleTitle.preparation_and_training': 'Sagatavošanās un apmācības',
  'moduleTitle.profile_guardian_consent': 'Vecāku / likumisko pārstāvju piekrišana',
  'moduleTitle.profile_questions': 'Profila jautājumi',
  'moduleTitle.registration_for_level': 'Reģistrēties nākamajam līmenim',
  'moduleTitle.residential_project': 'Projekts',
  'moduleTitle.residential_project_details': 'Informācija par projektu',
  'moduleTitle.reset_password': 'Paroles maiņa',
  'moduleTitle.welcome_to_the_orb': 'Sveicam Tiešsaistes sasniegumu grāmatā',
  'moduleTitle.we_have_sent_you_an_email': 'Mēs nosūtījām tev e-pasta vēstuli ar aktivizēšanas saiti.',
  'moduleTitle.your_registration_is_complete': 'Tava reģistrācija ir pabeigta',
  'formTitle.activity_details': 'Aktivitātes apraksts',
  'formTitle.assessor_details': 'Ziņas par novērtētāju',
  'formTitle.supervisors_details': 'Ziņas par uzraugu',
  'formTitle.preparation_and_training_activities': 'Sagatavošanās un apmācību aktivitātes',
  'formTitle.added_preparation_activities': 'Pievienotās sagatavošanās un apmācību aktivitātes',
  'label.add_picture': 'Pievienot bildi',
  'label.address_first_line': 'Adrese',
  'label.address_second_line': 'Adrese (papildlīnja)',
  'label.are_you_already_running_award': 'Vai tu jau īsteno Award?',
  'label.are_you_the_main_award_leader': 'Vai tu esi galvenais Award vadītājs vai savas Award vienības koordinators?',
  'label.award_participant': 'Award dalībnieks',
  'label.award_leader': 'Award vadītājs',
  'label.birthdate': 'Dzimšanas datums',
  'label.category': 'Kategorija',
  'label.change_locale': 'Mainīt vietu',
  'label.choose_project': 'Izvēlēties aktivitāti',
  'label.city': 'Pilsēta',
  'label.choose_as_major_activity': 'Izvēlies kā "garāko jomu"',
  'label.date': 'Datums',
  'label.date_of_birth': 'Dzimšanas datums',
  'label.description_of_progress': 'Tava progresa apraksts',
  'label.duration': 'Ilgums (stundas / minūtes)',
  'label.email': 'E-pasts',
  'label.email_address': 'E-pasta adrese',
  'label.email_again': 'Apstiprināt e-pastu',
  'label.employment_status': 'Nodarbinātības statuss',
  'label.end_date': 'Beigu datums',
  'label.enter_his_email': 'Ievadi e-pastu',
  'label.entered_transaction_id': 'Tavas transakcijas ID',
  'label.first_name': 'Vārds',
  'label.gender': 'Dzimums',
  'label.goal': 'Mērķis',
  'label.journey_activity': 'Ceļojuma aktivitāte',
  'label.journey_objective': 'Ceļojuma mērķis',
  'label.journey_observations': 'Ceļojuma novērojumi',
  'label.journey_type': 'Ceļojuma veids',
  'label.last_name': 'Uzvārds',
  'label.level': 'Līmenis',
  'label.location': 'Vieta',
  'label.logout': 'Izlogoties',
  'label.major': '"Garākā joma"',
  'label.middle_name': '',
  'label.mode_of_transport': 'Pārvietošanās veids',
  'label.my_award_leader': 'Mans Award vadītājs',
  'label.name': 'Vārds',
  'label.nationality': 'Tautība',
  'label.no': 'Nē',
  'label.no_results': 'Nav rezultātu',
  'label.note': 'Ziņa',
  'label.note_for_assessor': 'Ziņa novērtētājam',
  'label.note_for_leader': 'Ziņa Award vadītājam',
  'label.optional': 'izvēles',
  'label.organisation_name': 'Organizācijas nosaukums',
  'label.organisation_type': 'Ogranizācijas veids',
  'label.others': 'Citi',
  'label.password': 'Parole',
  'label.password_again': 'Atkārtot paroli',
  'label.project_location': 'Projekta norises vieta',
  'label.pay_online': 'Maksāt tiešsaistē',
  'label.pay_award_leader_or_unit': 'Maksāt Award vadītājam vai vienībai',
  'label.payment_not_required': 'Dalībniekam nav jāmaksā',
  'label.payment_type': 'Samaksas veids:',
  'label.phone': 'Tālrunis',
  'label.phone_number': 'Tālruņa numurs',
  'label.phone_type': 'Tālruņa tips',
  'label.profile': 'Profils',
  'label.reset_password': 'Paroles atjaunošana',
  'label.region': 'Pašvaldība',
  'label.relationship': 'Saistības',
  'label.role_in_organisation': 'Loma organizācijā',
  'label.select_country': 'Izvēlies valsti',
  'label.select_your_au': 'Izvēlies savu Award vienību',
  'label.start_typing': 'Sāc rakstīt',
  'label.start_date': 'Sākuma datums',
  'label.select': 'Izvēlēties',
  'label.select_async': 'Sāc rakstīt...',
  'label.select_your_operating_authority': 'Izvēlies savu operatoru',
  'label.specify_category': 'Lūdzu, precizē savu kategoriju',
  'label.subcategory': 'Apakškategorija',
  'label.title': 'Uzruna',
  'label.username': 'Lietotājvārds',
  'label.what_is_your_role': 'Kāda ir tava loma organizācijā?',
  'label.where_have_you_completed': 'Kur tu pabeidzi?',
  'label.yes': 'Jā',
  'label.your_changes_havent_been_saved': 'Veiktās izmaiņas nav saglabātas. Dati būs zuduši.',
  'label.zip': 'Pasta indekss',
  'label.adventurous_journey': 'Piedzīvojumu ceļojums',
  'label.after_your_journey_describe': 'Dažos teikumos apraksti savus ceļojuma novērojumus.',
  'label.because_your_age_is_under_18': 'Tu esi nepilngadīga persona, tādēļ mums ir nepieciešams tavu vecāku/likumisko pārstāvju atļauja. ',
  'label.before_you_head_to_journey': 'TPirms ieskaites ceļojuma tev jāpabeidz sagatavošanās un apmācības.',
  'label.before_entering_new_level': 'Pirms uzsāc nākamo līmeni, lūdzu, apskaties, vai tavi dati joprojām ir aktuāli',
  'label.bring_required_amount_to_your_award_leader': 'Atnes nepieciešamo summu savam Award vadītājam vai Award vienības koordinatoram',
  'label.do_you_have_any_other_level': 'Vai iepriekš pabeidzi kādu no Award līmeņiem?',
  'label.do_you_know_who_is_your_award_leader': 'Vai tu zini, kas ir tavs Award vadītājs?',
  'label.going_on_an_expedition': 'Došanās ceļojumā ir piedzīvojums, kurā tu vari darboties komandā un uzņemties iniciatīvu.',
  'label.going_on_residential_gives_chance': 'Projekta tev dod iespēju mācīties sadarboties ar cilvēkiem ar citādu dzīves pieredzi un gūt pārliecību darboties jaunā vidē.',
  'label.i_confirm_that_i_meet': 'Es apstiprinu, ka es atbilstu visām Nacionālā Award operatora prasībām',
  'label.i_agree_to_volunteer_code': 'Es piekrītu brīvprātīgo rīcības kodeksam. Lai iegūtu plašāku informāciju, spied šeit.',
  'label.i_have_read_the_terms_and_conditions': 'Es iepazinos ar noteikumiem un piekrītu tiem.',
  'label.i_will_bring_the_consent_to_my_award_leader_later': 'Es vēlāk atnesīšu atļauju savam Award vadītājam',
  'label.if_you_are_from_orphanage': 'Piemēram, ja skola vai jauniešu organizācija samaksā tavā vietā.',
  'label.here_you_can_add_activity': 'Šeit tu vari norādīt papildu sagatavošanās un apmācību aktivitātes.',
  'label.how_do_you_want_to_apply': 'Kā tu vēlies pieteikties:',
  'label.my_parent_consent_has_been_already_given': 'Mani vecāki/likumiskie pārstāvji atļauju ir atdevuši manam Award vadītājam.',
  'label.my_parent_will_confirm_consent_by_email': 'Mani vecāki/likumiskie pārstāvji nosūtīs atļauju pa e-pastu',
  'label.major_activity_means_that_you_have_to_spent': '"Garākā joma" nozīmē, ka tev vienas jomas mērķa sasniegšanai būs jāvelta papildu laiks. Zelta un sudraba līmenī šis papildu laiks ir seši mēneši, bronzas līmenī - trīs mēneši.',
  'label.not_sure_about_your_auth': 'Ja nav pārliecības par to, kas ir tavs Award operators, sazinies ar reģionālo biroju.',
  'label.page_not_found': '404 - lapa netika atrasta.',
  'label.please_fill_in_the_following': 'Lūdzam norādīt informāciju par organizācijas paraksttiesīgo personu',
  'label.register_a_new_account_as': 'Reģistrē jaunu kontu kā:',
  'label.residential_project': 'Projekts',
  'label.select_your_award_unit': 'Izvēlies savu Award vienību',
  'label.the_expedition_can_be_faraway': 'Ceļojums var notikt tik tālu vai tuvu tavām mājām, cik tu to vēlies, turklāt ir simtiem iespēju, kā tu to vari paveikt.',
  'label.to_log_your_process_on_orb': 'Lai pabeigtu tava Tiešsaistes sasniegumu grāmatas profila izveidi, lūdzu, zemāk norādi paroli.',
  'label.waiting_for_assessment': 'Gaida novērtējumu',
  'label.waiting_for_sign_off': 'Gaida Award vadītāja apstiprinājumu.',
  'label.we_have_sent_you_an_email': 'Mēs nosūtījām tev e-pasta vēstuli ar aktivizēšanas saiti.',
  'label.what_level_of_the_award': 'Kuram Award līmenim tu reģistrējies?',
  'label.you_are_now_registering_as_participant': 'Šobrīd tu reģistrējies kā Award dalībnieks.',
  'label.you_are_now_registering_as_award_unit': 'Šobrīd tu reģistrējies kā Award vienība.',
  'label.you_can_use_my_photos_for_promotional_purposes': 'Es kā Award dalībnieks ļauju Fondam izmantot savus attēlus / bildes reklāmas nolūkiem.',
  'label.you_can_send_activity_for_approval': 'Tagad tu vari nosūtīt savu aktivitāti apstiprināšanai savam novērtētājam.',
  'label.you_can_send_activity_for_leader': 'Tagad tu vari nosūtīt savu aktivitāti apstiprināšanai savam Award vadītājam,',
  'label.you_can_send_residential_project_to_leader': 'Tagad tu vari nosūtīt savu projektu apstiprināšanai savam Award vadītājam.',
  'label.you_have_finished_now_send_to_approval': 'Tava aktivitāte ir pabeigta. Tagad tu vari to iesniegt apstiprināšanai savam novērtētājam. Zemāk tu vari pievienot ziņu.',
  'label.preparation_and_training': 'Sagatavošanās un apmācības',
  'label.you_will_be_redirected_to_the_payment': 'Klikšķini uz pogas "Maksāt", lai veiktu tiešsaistes maksājumu ar savu Visa, MasterCard kredītkarti vai Visa debetkarti.',
  'label.you_will_be_the_first_award_leader': 'Tu esi pirmais Award vadītājs savā organizācijā. Tev būs tiesības pievienot citus Award vadītājus un dalībniekus un pārvaldīt procesus, kas saistīti ar Award, izmantojot Tiešsaistes sasniegumu grāmatas sistēmu.',
  'label.youll_receive_a_notification': 'Tiklīdz Award vadītājs būs apstiprinājis tavu reģistrāciju, tu saņemsi paziņojumu. Tiešsaistes sasniegumu grāmatā varēsi ielogoties <a>šeit</a> (kamēr Award vadītājs apstiprina tavu reģistrāciju, tev būs limitēta funkcionalitāte).',
  'label.your_parent_email': 'Tava tēva vai mātes / likumiskā pārstāvja e-pasts',
  'label.your_parent_first_name': 'Tava tēva vai mātes / likumiskā pārstāvja vārds',
  'label.your_parent_last_name': 'Tava tēva vai mātes / likumiskā pārstāvja uzvārds',
  'label.your_report_approve_now_send_to_leader': 'Tavs pārskats ir apstiprināts! Tagad tu vari iesniegt savu pārskatu apstiprināšanai savam Award vadītājam. Zemāk tu vari pievienot ziņu.',
  'label.there_are_loads_of_exciting_possibilities': 'Ir daudz aizraujošu iespēju. Izvēlies to, kas tev sniegs piepildījuma sajūtu.',
  'label.your_residential_project_has_been_setup': 'Tavs projekts ir izveidots un nosūtīts apstiprināšanai tavam Award vadītājam.',
  'label.your_report_has_been_sent_assessor': 'Tavs pārskats ir nosūtīts apstiprinašānai tavam novērtētājam.',
  'label.your_report_has_been_sent_leader': 'Tavs pārskats ir nosūtīts apstiprinašānai tavam Award vadītājam.',
  'label.your_residential_project_is_complete': 'Projekts ir pabeigts.',
  'label.to_work_on_the_online': 'Lai darbotos Tiešsaistes Sasniegumu grāmatā (TSG), tev vajadzīgs savs TSG konts.',
  'label.we_will_send_you_an_email': 'Mēs nosūtīsim tev e-pastu, tiklīdz tava TSG konta reģistrācija būs apstiprināta.',
  'label.if_you_have_any_problems_or_doubts': 'Ja ir kādas problēmas vai jautājumi, tad sazinies ar savu Award vadītāju.',
  'label.are_you_sure_you_want_to_leave': 'Vai tiešām vēlies pamest? Dati tiks pazaudēti.',
  'label.no_logs_yet': 'Pagaidām nav ierakstu.<br />Mēģini izveidot savu pirmo ierakstu, nospiežot pogu "Pievienot ierakstu".',
  'label.menu': 'Izvēlne',
  'notifications.award_unit_has_been_created': 'Award vienība ir izveidota',
  'notifications.authorization_code_is_not_valid': 'Autorizācijas kods nav derīgs - izskatās, ka iepriekš izmantoji šo kodu',
  'notifications.email_has_been_confirmed': 'E-pasta adrese ir apstiprināta',
  'notifications.leader_has_been_created': 'Izveidots vadītājs',
  'notifications.participant_has_been_created': 'Izveidots dalībnieks',
  'notifications.email_with_instructions_has_been_sent': 'E-pasts ar instrukciju ir nosūtīts.',
  'notifications.your_new_password_has_been_set': 'Izveidota jauna parole',
  'notifications.success': 'Panākums',
  'notifications.unknown_role': 'Nav zināma loma',
  'notifications.waiting_for_approval': 'Gaida apstiprinājumu',
  'notifications.activity_cannot_be_created': 'Aktivitāte nevar tikt izveidota, kamēr nav apstiprināta tava reģistrācija',
  'notifications.new_activity_has_been_added': 'Pievienota jauna aktivitāte',
  'notifications.new_log_has_been_added': 'Pievienots jauns ieraksts',
  'notifications.log_has_been_deleted': 'Ieraksts ir izdzēsts',
  'notifications.log_has_been_modified': 'Ieraksts ir pārveidots',
  'notifications.adventurous_journey_cannot_be_created_until_approved': 'Piedzīvojumu ceļojums nevar tikt izveidots, kamēr nav apstiprināta tava reģistrācija',
  'notifications.new_participant_event_has_been_added': 'Dalībnieks pievienojis jaunu notikumu',
  'notifications.participant_event_has_been_completed': 'Pabeigts dalībnieka notikums',
  'notifications.training_and_practice_modified': 'Pārveidotas apmācības un sagatavošanās',
  'notifications.completion_residential_project_completed': 'Pabeigts projekts',
  'notifications.new_residential_project_has_been_added': 'Pievienots jauns projekts',
  'notifications.residential_project_cannot_be_created_until_approved': 'Projekts nevar tikt izveidots, kamēr nav apstiprināta tava reģistrācija',
  'notifications.already_assessed_sent': 'Pieprasījums pēc vadītāja apstiprinājuma ir nosūtīts',
  'notifications.assessment_request_sent': 'Novērtēšanas pieprasījums ir nosūtīts',
  'notifications.leader_approval_sent': 'Pieprasījums pēc vadītāja apstiprinājuma ir nosūtīts',
  'tabs.logs': 'Ieraksti',
  'tabs.new': 'Jauns',
  'tabs.overview': 'Pārskats',
  'tabs.report': 'Pārskats',
  'button.add_activity': 'Pievienot aktivitāti',
  'button.add_log': 'Pievienot ierakstu',
  'button.continue_here': 'Turpini šeit',
  'button.continue': 'Turpini',
  'button.continue_to_award': 'Turpināt Award',
  'button.delete': 'Dzēst',
  'button.edit': 'Labot',
  'button.edit_log': 'Labot ierakstu',
  'button.finish': 'Pabeigt',
  'button.forgot_your_password': 'Aizmirsi savu paroli?',
  'button.i_already_have_assessment': 'Man jau ir novērtējums',
  'button.leave_anyway': 'Pamest jebkurā gadījumā',
  'button.login': 'Ielogoties',
  'button.no': 'Nē',
  'button.register': 'Reģistrēties',
  'button.send': 'Sūtīt',
  'button.send_for_approval': 'Sūtīt apstiprināšanai',
  'button.setup': 'Uzstādīt',
  'button.setup_residential': 'Izveidot projektu',
  'button.stay': 'Palikt',
  'button.submit': 'Iesniegt',
  'button.update': 'Atjaunināt',
  'button.yes': 'Jā',
  'errors.at_least_num_characters': 'Vismaz {length} rakstzīmes',
  'errors.do_not_match': 'Nesakrīt',
  'errors.include_at_least_one_number': 'Iekļauj vismaz vienu ciparu',
  'errors.include_both_lower_and_upper_case': 'Iekļauj gan mazos, gan lielos burtus',
  'errors.invalid_phone_format': 'Nederīgs tālruņa numura formāts',
  'errors.invalid_email_address': 'Nederīgs e-pasta adreses formāts',
  'errors.required_field': 'Obligātais lauks',
  'errors.must_be_at_least': 'Jābūt vismaz {min} rakstzīmēm',
  'errors.must_be_no_more_than': 'Jābūt ne vāirāk kā {max} rakstzīmēm',
  'errors.must_be_an_integer': 'Jābūt veselam skaitlim',
  'errors.must_contain_at_least': 'Jābūt vismaz vienam ciparam',
  'errors.must_include_at_least': 'Jābūt vismaz vienam lielajam burtam',
  'errors.must_be_one_of': 'Jābūt vienam no: {enums}',
  'errors.you_must_be_younger_than': 'Tev nevar būt vairāk kā {years} gadi un {months} mēneši, lai reģistrētos Award. Lūdzam sazināties ar Award vienības pārstāvjiem.',
  'errors.you_must_be_older_than': 'Tev nevar būt mazāk kā {years} gadi un {months} mēneši, lai reģistrētos Award. Lūdzam sazināties ar Award vienības pārstāvjiem.',
  'errors.email_address_is_in_use_please_sign': 'E-pasta adrese jau tiek izmantota, ja vēlies reģistrēties nākamajam līmenim, lūdzu, ielogojies savā profilā.',
  'errors.email_address_is_in_use': 'E-pasta adrese jau tiek izmantota.',
  'errors.sorry_we_already_have_this_email': 'Piedod, šāds e-pasts jau ir saistīts ar eksistējošu kontu. Ja vēlies sākt nākamo līmeni, <a href=\'/\'>ielogojies savā kontā</a> un izvēlies opciju "Sākt nākamo līmeni".',
  'wizard.authorising_contact': 'Pilnvarotā kontaktpersona',
  'wizard.award_leader_contact': 'Award vadītāja kontakti',
  'wizard.award_unit_details': 'Informācija par Award vienību',
  'wizard.contact_details': 'Kontakinformācija',
  'wizard.contacts': 'Kontakti',
  'wizard.level': 'Award līmenis',
  'wizard.level_selection': 'Award izvēle',
  'wizard.leader_details': 'Informācija par vadītāju',
  'wizard.nominated_award_leader': 'Award vienības koordinators',
  'wizard.orb_account': 'TSG konts',
  'wizard.parent_consent': 'Vecāku atļauja',
  'wizard.participant_details': 'Informācija par dalībnieku',
  'wizard.profile': 'Profils',
  'wizard.payment': 'Maksājums',
  'wizard.select_award_unit': 'Izvēlēties Award vienību',
  'wizard.unit_details': 'Informācija par Award vienību',
  'wizard.welcome': 'Sveicam!',
  'wizard.your_details': 'Informācija par tevi',
  'awardUnit.do_you_want_to_create': 'Vai vēlies izveidot jaunu Award vienību?',
  'parent.you_can_download_the_consent_here': 'Ja tev nav iedota vecāku atļaujas formas, tu vari lejupielādēt to šeit. Palūdz, lai kāds no vecākiem/likumiskais pārstāvis to paraksta, un iesniedz savam Award vadītājam.',
  'footer.copyright': "&copy; Autortiesības The Duke of Edinburgh's International Award 2017",
  'registration_participant.required_award_payment': 'Nepieciešamais maksājums',
  'registration_participant.pay_online_here': 'Maksā tiešsaistē un saņem savu transakcijas ID šeit.',
  'dashboard.activity_log_time': '{hours}h {minutes}min',
  'moduleTitle.award_completed': 'Līmenis ir pabeigts!',
  'notifications.award_approval_request_sent_to_leader': 'Pieteikums apbalvojuma saņemšanai ir nosūtīts tavam Award vadītājam',
  'notifications.new_participant_event_has_been_completed': 'Jauns dalībnieka notikums ir pabeigts',
  'notifications.preparation_and_training_approval_sent': 'Sagatavošanās un apmācību apstiprinājums ir nosūtīts',
  'notifications.reparation_and_training_completed': 'Sagatavošanās un apmācības ir pabeigtas',
  'notifications.your_profile_photo_has_been_edited': 'Tava profila bilde ir nomainīta',
  'notifications.your_profile_has_been_edited': 'Tavs profils ir labots',
  'notifications.new_level_has_started': 'Nākamais līmenis ir sācies',
  'notifications.activity_has_been_edited': 'Aktivitāte ir labota',
  'notifications.you_have_been_logged_out': 'Notiek izlogošanās...',
  'notifications.logging_out': 'Tu esi izlogojies',
  'label.you_can_send_award_to_leader': 'Tagad tu vari nosūtīt izskatīšanai savu pieteikumu apbalvojuma saņemšanai savam Award vadītājam',
  'label.you_have_completed_all_sections_of_your_award': 'Tu esi pabeidzis visas Award jomas! Tagad tu vari nosūtīt pieteikumu apbalvojuma saņemšanai savam Award vadītājam. Zemāk tu vari pievienot ziņu.',
  'label.you_have_now_completed_your_award': 'Tu esi pabeidzis savu Award {level} līmeni. Vai vēlies sākt nākamo līmeni?',
  'label.congratulation_your_award_has_been_approved': 'Apsveicam. Tu pabeidzi Award {level} līmeni! <br /> Ja vēleis, vari sākt nākamo līmeni.',
  'moduleTitle.settings': 'Iestatījumi',
  'moduleTitle.edit_activity': 'Labot aktivitāti',
  'moduleTitle.select_your_major_activity': 'Izvēlies "garāko jomu"',
  'label.settings': 'Iestatījumi',
  'label.major_activity_means_that_you_will': '"Garākā joma" nozīmē, ka tev vienas jomas mērķa sasniegšanai būs jāvelta papildu laiks. Zelta un sudraba līmenī šis papildu laiks ir seši mēneši, bronzas līmenī - trīs mēneši.',
  'label.notifications': 'Paziņojumi',
  'label.my_award': 'Mans Award',
  'label.physical_recreation': 'Fiziskā sagatavotība',
  'label.skill': 'Prasmes',
  'label.service': 'Brīvprātīgais darbs',
  'label.my_parent_will_complete_and_sign_form': 'Mans tēvs vai māte/likumiskais pārstāvis aizpildīs un parakstīs vecāku/likumiskā pārstāvja atļaujas formu',
  'label.please_print_it_tak_it_to_your_parent': 'Ja tev nav iedota vecāku atļaujas formas, tu vari lejupielādēt to šeit. Palūdz, lai kāds no vecākiem/likumiskais pārstāvis to paraksta, un iesniedz savam Award vadītājam.',
  'label.change_password': 'Mainīt paroli',
  'label.change_major_activity': 'Mainīt "garāko jomu"',
  'title.change_password': 'Mainīt paroli',
  'label.old_again': 'Iepriekšējā parole',
  'label.new_password': 'Jaunā parole',
  'label.new_password_again': 'Jaunā parole - atkārtoti',
  'errors.passwords_dont_match': 'Paroles nesakrīt',
  'errors.more_than': 'Vairāk nekā {limit}',
  'button.parent_guardian_consent_pdf': 'Vecāku/likumiskā pārstāvja atļauja.pdf',
  'button.send_award_for_approval': 'Nosūtīt Award apstiprināšanai',
  'button.send_report': 'Sūtīt pārskatu',
  'button.terms_and_conditions': 'Starptautiskie noteikumi un nosacījumi',
  'button.privacy_policy': 'Privātuma politika',
  'button.save': 'Saglabāt',
  'button.start_new_level': 'Sākt nākamo līmeni',
  'button.change_password': 'Mainīt paroli',
  'button.edit_activity': 'Labot aktivitāti',
  'moduleTitle.file_upload': 'Augšupielādēt failu',
  'label.add_file': 'Pievienot failu',
  'label.description': 'Apraksts',
  'label.waiting_for_office_sign_off': 'Gaida Nacionālā operatora apstiprinājumu',
  'notifications.file_has_been_uploaded': 'Fails ir augšupielādēts',
  'tabs.files': 'Faili',
  'button.upload': 'Augšupielādēt',
  'button.upload_file': 'Augšupielādēt failu',
  'button.add_file': 'Pievienot failu',
  'button.this_activity_has_no_assessor': 'Šai aktivitātei nav novērtētāja. Pirms sūti to apstiprināšanai, norādi informāciju par novērtētāju.',
  'label.i_want_to_register_my_award': 'Vēlos savu Award vienību reģistrēt kā Neatkarīgo Award centru',
  'label.select_sub_operating_authority': 'Izvēlies apakš-operatoru',
  'label.your_must_first_setup_some_activity': 'Vispirms tev jāizveido kādas aktivitātes',
  'label.you_cant_change_your_major_activity': 'Tu vairs nevari mainīt "garāko jomu". Tava "garākās jomas" aktivitate jau ir pabeigta',
  'label.s_specific': '<b>K-Konkrēts: Tavam mērķim nevajadzētu būt pārāk plašam.</b> "Es vēlos pilnveidot vijoles spēli" aizvieto ar "Es vēlos pilnveidot vijoles spēli Fa mažorā."',
  'label.m_measurable': '<b>I-Izmērāms: Izmanto ciparus, daudzumu, lielumu vai jebko citu, kas norādīs, kad mērķis būs sasniegts.</b>Tā vietā, lai teiktu, mans mērķis ir "Palīdzēt sabiedrībai", formulē savu mērķi šādi: "Vienu reizi nedēļā es veikšu brīvprātīgo darbu zupas virtuvē."',
  'label.a_achievable': '<b>S-Sasniedzams: Tavam mērķim vajadzētu būt tādam, ko var sasniegt attiecīgā Award līmeņa ietvaros.</b> Tā vietā, lai teiktu: "Es vēlos, lai pasaulē vairs nebūtu bada", izvirzi sev praktiski sasniedzamu mērķi, piemēramm "Vākt līdzekļus priekš organizācijas, kas sniedz palīdzību trūkumcietējiem."',
  'label.r_realistic': '<b>R-Reālistisks: Mērķim jābūt tādam, kas ir sasniedzams, ņemot vērā situāciju un iespējas.</b>  Vai spēsi izvirzīto mērķi sasniegt attiecīgā Award līmeņa ietvaros?',
  'label.t_timely': '<b>T-Terminēts: Savā mērķa formulējumā norādi to, pēc cik ilga laika mērķim jābūt sasniegtam.</b> Piemēram: "Trīs mēnešu laikā pilnveidošu vijoles spēli Fa mažorā."',
  'label.you_can_upload_here_any_files': 'Tu vari augšupielādēt jebkādu failu (10 MB vai mazāku), kuru šeit vēlies parādīt savam Award vadītājam. ',
  'moduleTitle.login_change': 'Ielogošanās izmaiņas',
  'notifications.adventurous_journey_modified': 'Piedzīvojumu ceļojums ir labots',
  'tabs.sections': 'Izvēles',
  'label.change_email': 'Mainīt e-pastu',
  'title.change_email': 'Mainīt e-pastu',
  'label.new_email': 'Jauns e-pasts',
  'label.new_email_again': 'Apstiprināt e-pastu',
  'errors.emails_dont_match': 'E-pasti nesakrīt',
  'button.change_email': 'Mainīt e-pastu',
  'notifications.email_with_instructions_has_been_sent_to_your_inbox': 'E-pasts ar instrukciju ir nosūtīts uz tavu e-pastu',
  'global.dofe_name': 'The Duke of Edinburgh’s International Award',
  'global.or': 'vai',
  'route.landing_page': 'Galvenā lapa',
  'route.dashboard': 'Panelis',
  'moduleTitle.notifications': 'Paziņojumi',
  'moduleTitle.no_notifications': 'Nav paziņojumu',
  'moduleTitle.new_notifications': 'Jauns paziņojums',
  'moduleTitle.older_notifications': 'Iepriekšējie paziņojumi',
  'moduleTitle.user_guide': 'Pamācība lietotājam',
  'label.user_guide': 'Pamācība lietotājam',
  'notifications.your_password_has_been_changed': 'Tava parole ir nomainīta',
  'label.country': 'Valsts',
  'label.on_your_smartphone': 'Viedtālrunī',
  'label.on_the_web': 'Tīmeklī',
  'label.orb_online': 'TSG tiešsaistē',
  'label.language': 'Valoda',
  'moduleTitle.participant_login': 'Dalībnieka ieraksts',
  'label.for_ios': 'priekš iOS',
  'label.for_android': 'priekš Android',
  'button.login_as_award_staff': 'Ielogoties kā Award personālam',
  'errors.leader_doesnt_exist': 'Šāda vadītāja nav',
  'global.loading': 'Ielāde',
  'moduleTitle.award_staff_login': 'Award personāla ieraksts',
  'formTitle.residential_project_details': 'Informācija par projektu',
  'label.you_can_also_download_participant': 'Tu vari lejupielādēt <strong>Dalībnieka lietotni</strong> un piekļūt Tiešsaistes sasniegumu grāmatai jebkurā laikā un vietā.',
  'label.you_can_also_download_leader': 'Tu vari lejupielādēt <strong>Dalībnieka lietotni</strong> un piekļūt Tiešsaistes sasniegumu grāmatai jebkurā laikā un vietā.',
  'notifications.this_role_is_not': 'Šāda loma pagaidām netiek atbalstīta',
  'notifications.residential_project_has_been_updated': 'Projekts ir atjaunināts',
  'tabs.participant': 'Dalībnieks',
  'tabs.award_staff': 'Award personāls',
  'moduleTitle.edit_residential_project': 'Labot projektu',
  'button.residential_project': 'Labot projektu',
  'notifications.your_login_email_has_been_changed': 'Tavs pieslēgšanās e-pasts ir mainīts',
  'meta.dofe_name': 'The Duke of Edinburgh’s International Award',
  'notifications.unknown_role_leader': 'Nav zināma loma - pieslēgties kā Award personāla pārstāvim',
  'notifications.unknown_role_participant': 'Nav zināma loma - pieslēgties kā dalībniekam',
  'label.user_guide_web_participant': 'Pamācība dalībniekam - tīmekļa lietotājam',
  'label.user_guide_app_participant': 'Pamācība dalībniekam - lietotnes lietotājam',
  'label.note_for_supervisor': 'Ziņa uzraugam',
  'label.before_submitting_your_aj': 'Pirms piesaki ceļojumu savam Award vadītājam, tev vispirms jāsaņem apstiprinājums no sava {role}. Ja vēlies,vari pievienot ziņu.',
  'button.back_to_home': 'Uz sākumlapu',
  'moduleTitle.assessor_approval': '{role} apstiprinājums\n',
  'label.this_aj_has_no_assessor': 'Šim piedzīvojumu ceļojumam nav {role}. Atjaunini informāciju pirms nosūti ceļojumu apstiprināšanai.',
  'route.not_found': 'Nav atrasts',
  'notifications.are_you_sure': 'Vai tiešām?',
  'button.cancel': 'Atcelt',
  'label.add_document': 'Pievienot dokumentu',
  'errors.there_are_currently_no_details_for_your': 'Pagaidām nav informācijas par tavu {role}. Pirms sūti aktivitāti apstiprināšanai, norādi trūkstošo informāciju',
  'moduleTitle.missing_data': 'Trūkst datu',
  'label.to_send_assessment_request': 'Ja vēlies lūgumu pēc novērtējuma sūtīt elektroniski, lūdzu norādi {role} e-pastu.',
  'label.pending_changes': 'Gaida izmaiņas ...',
  'label.some_fields_require': 'Pievērs uzmanību obligātajiem laukiem',
  'roles.assessor': 'Novērtētājs',
  'roles.supervisor': 'Uzraugs',
  'pageTitle.register_participant': 'Reģistrēt dalībnieku',
  'moduleTitle.revise_message': 'Atgriešanas ziņa',
  'moduleTitle.payment_for_level': 'Samaksa par {awardLevel}',
  'moduleTitle.payment': 'Dalībnieka reģistrācijas maksas samaksa',
  'moduleTitle.we_have_sent_you_payment_link': 'Mēs nosūtījām tev e-pastu vēstuli ar saiti uz tiešsaistes maksājumu.',
  'label.required_award_payment': 'Nepieciešamais maksājums',
  'label.payment_fees': 'maksājuma izmaksas',
  'label.payment_method': 'Apmaksas veidi',
  'label.you_will_type_trans_id': 'Tev būs jāieraksta transakcijas ID.',
  'label.any_level_previously': 'Līdz šim pabeigtie līmeņi',
  'label.registering_for_level': 'Reģistrēšanās līmenim',
  'notification.payment_link_expired': 'Saistītajam maksājumam iztecējis termiņš',
  'button.pay': 'Maksāt',
  'label.registration_updated': 'Reģistrācija ir atjaunināta, vari aizvērt šo lapu.',
  'label.award_leader_receive_payment': 'Award vadītājs saņem informāciju par veikto maksājumu.',
  'errors.end_date_after': 'Beigu datumam jābūt pēc sākuma datuma',
  'button.back': 'Atpakaļ',
  'button.edit_info': 'Labo informāciju',
  'moduleTitle.level_detail': 'Informācija par līmeni',
  'label.payment_methods': 'Maksājuma veidi',
  'label.address': 'Adrese',
  'note.review_filled_participant': 'Lūdzam pārskatīt informāciju, ko iesniedza dalībnieks. Ja kaut kas ir nepareizi, tu vari to izlabot.',
  'moduleTitle.payment_successful': 'Dalībnieka reģistrācijas maksājums veiksmīgi izpildīts. ',
  'button.proceed_to_login': 'Ielogoties',
  'label.add_additional_activity': 'Pievienot papildu aktivitāti',
  'moduleTitle.welcome_to_orb': 'Sveicam Tiešsaistes sasniegumu grāmatā',
  'empty_dashboard.not_approved': 'Šis rīks palīdzēs fiksēt tavu veikumu, tomēr pagaidām Award vadītājs nav apstiprinājis tavu profilu. Sagaidi apstiprināju un tad ķeries klāt savas pirmās aktivitātes izveidošanai.',
  'empty_dashboard.approved_1': 'Šis rīks palīdzēs fiksēt tavu veikumu.',
  'empty_dashboard.approved_2': 'Vispirms tev ir jāizveido aktivitāte. Lai sāktu, noklikšķini uz kādu no tām, kas ir kreisajā pusē. Ja tev ir vajadzīga palīdzība, lai izveidotu aktivitāti, vērsies pie sava Award vadītāja.',
  'label.discuss_activity_leader': 'Ja vēlies norādīt vairākas aktivitātes, apspriedies ar savu Award vadītāju.',
  'label.cannot_add_activity': 'Šajā kategorijā tu vari pievienot maksimums 3 aktivitātes. Lūdzam, par šo apspriedies ar savu Award vadītāju.',
  'button.ok': 'Labi',
  'label.payment_was_canceled': 'Lietotājs atcēla maksājumu',
  'label.problem_with_payment': 'Apstrādājot maksājumu, radās problēma. Lūdzam sazinieties ar Nacionālo operatoru.',
  'pageTitle.register_leader': 'Reģistrēt vadītāju',
  'pageTitle.registration_complete': 'Reģistrācija pabeigta',
  'label.payment_link_expired_or_paid': 'Tu jau samaksāji reģistrācijas maksu VAI maksājuma saitei ir beidzies derbības termiņš.',
  'label.contact_nao_assistance': 'Sazinies ar savu Nacionālo operatoru, ja tev vajadzīgs atbalsts',
  'label.send_required_amount_to_your_award_leader': 'Nosūtīt vajadzīgo summu Award vadītājam vai Award vienības koordinatoram',
  'label.fee_can_be_paid': 'Maksājumu var veikt tiešsaistē, izmantojot VISA vai Master Card kredīta vai debeta kartēm',
  'notifications.login_failed_right_tab': 'Neveiksmīga ielogošanās. Pārliecinies, vai izmanto pareizo piekļuves ceļu (Dalībnieks / Award personāls).',
  'label.i_have_read_privacy_policy': 'Es izlasīju Privātuma politiku un piekrītu tai.',
  'errors.invalid_date_format': 'Nederīgs datuma formāts',
  'label.no_privacy_policy': 'Tu vari turpināt, nospiežot pogu "Beigt"',
  'label.status': 'Statuss',
  'moduleTitle.attached_with_observation': 'Pievienots ar novērojumiem',
  'moduleTitle.revise_message_rp': 'Tavs Award vadītājs ir atgriezis tavu projektu.',
  'file.activity_section_summary': '{section}-jomas kopsavilkums',
  'label.download_section_summary': 'Lejupielādēt jomas kopsavilkumu',
  'label.award_summary': 'Award kopsavilkums',
  'btn.download_summary_for_assessor': 'Lejupielādēt kopsavilkumu priekš novērtētāja',
  'label.first_activity_started': 'Pirmā aktivitāte uzsākta',
  'label.hours_completed_required': 'Pabeigtās/obligātās stundas',
  'label.weeks_completed_required': 'Pabeigtās/obligātās nedēļas',
  back_to_home: 'Atpakaļ uz sākumlapu',
  'label.activity_rejected_click': 'Tavs Award vadītājs ir atgriezis tavu aktivitāti. Klikšķini, lai ',
  'button.more_information': 'vairāk informācijas',
  'label.attached_file': 'Pievienotais fails',
  'moduleTitle.journey_details': 'Informācija par ceļojumu',
  'tabs.activity': 'Aktivitāte',
  'label.confirm_email': 'Apstiprināt e-pastu',
  'label.aj_rejected_click': 'Tavs Award vadītājs ir atgriezis tavu ceļojumu. Klikšķini, lai ',
  'label.verifying_payment': 'Maksājuma verificēšana',
  'button.finish_and_pay': 'Pabeigt un maksāt',
  'label.payment_not_successful_text': 'Ņemot vērā, ka iepriekš maksājums netika veiksmīgi veikts, ir nepieciešams maksājumu veikt tagad',
  'label.payment_not_completed': 'Maksājums nav pabeigts',
  'button.pay_now': 'Maksāt tagad',
  'label.registration_pending_parental_consent': 'Lai pabeigtu reģistrēšanos, nepieciešama tēva vai mātes / likumiskā pārstāvja atļauja',
  'button.edit_observation': 'Labot novērojumus',
  'moduleTitle.qualifying': 'Ieskaites',
  'moduleTitle.practice': 'Izmēģinājums',
  'label.first_log_entry': 'Pirmais ieraksts',
  'label.first_log_entry_date': 'Pirmā ieraksta datums',
  'label.last_log_entry': 'Pēdējais ieraksts',
  'label.last_log_entry_date': 'Pēdējā ieraksta datums',
  'label.you_can_send_journey_report_for_approval': 'Tu vari sūtīt apstiprināšanai sava {journey} ceļojuma pārskatu ',
  'button.edit_and_resend_report': 'Labot un atkārtoti sūtīt pārskatu',
  'label.your_journey_is_complete': 'Tavs {journeyType} ceļojums ir pabeigts.',
  'button.add_additional_journey': 'Pievienot papildu ceļojumu',
  'moduleTitle.edit_journey': 'Rediģēt ceļojumu',
  'notifications.assessment_sent': 'Novērtējums ir nosūtīts',
  'notifications.file_is_too_big': 'Failu nevar augšupielādēt. Faila izmēra limits ir 10 MB.',
  'notifications.authorization_code_has_expired': 'Autorizācijas koda derīguma termiņš drošības apsvērumu dēļ ir beidzies, lūdzam pieprasīt jaunu kodu',
  'route.confirm_email': 'Apstiprini e-pastu',
  'label.assessor_needs_account': 'Lai darbotos Tiešsaistes Sasniegumu grāmatā (TSG), tev vajadzīgs savs TSG konts.',
  'label.company_name': 'Uzņēmuma nosaukums',
  'label.secondary_email_again': 'Apstiprināt sekundāro e-pastu',
  'label.how_many_years': 'Cik gadus/mēnešus?',
  'label.no_company_leave_empty': 'Ja tu nestrādā, tad atstāj tukšu',
  'label.secondary_phone_number': 'Sekundārais tālruņa numurs',
  'label.secondary_phone_type': 'Sekundārā tālruņa tips',
  'label.wwc_application_number': 'Child Protection Number',
  'label.wwc_expiration_date': 'Child Protection expiration date',
  'label.you_are_now_registering_as_assessor': 'Šobrīd tu reģistrējies, lai kļūtu par novērtētāju',
  'label.you_have_finished_aj_now_send_to_approval': 'Tavs piedzīvojumu ceļojums ir pabeigts. Tagad tu vari to iesniegt apstiprināšanai savam novērtētājam. Zemāk tu vari pievienot ziņu.',
  'label.your_experience': 'Tava pieredze',
  'label.your_qualification': 'Tava kvalifikācija',
  'notifications.waiting_for_assessor_approval': 'Gaida novērtētāja apstiprinājumu',
  'button.resend_assessment_request': 'Vēlreiz nosūtīt lūgumu pēc novērtējuma',
  'errors.emails_must_be_different': 'Sekundārajam e-pastam jāattšķiras no primārā',
  'moduleTitle.company_details': 'Informācija par uzņēmumu',
  'notifications.already_resent_assessment_request': 'Tu jau esi nosūtījis atkārtotu novērtējuma pieprasījumu',
  'route.assessor_dashboard': 'Novērtētāja panelis',
  'pageTitle.register_assessor': 'Reģistrēt novērtētāju',
  'wizard.assessor_details': 'Ziņas par novērtētāju',
  'wizard.assessor_experience': 'Novērtētāja pieredze',
  'wizard.personal_details': 'Tavi dati',
  'button.sign_off': 'Iziet',
  'button.sign_off_dashed': 'Iziet',
  'moduleTitle.sign_off': 'Iziet',
  'label.certify_participant_met_reqs': 'Es, šīs aktivitātes novērtētājs, apliecinu, ka dalībnieks ir izpildījis visas prasības.',
  'label.assessor_report': 'Novērtētāja pārskats',
  'label.content_update': 'Lūdzam uzgaidīt. Notiek satura atjaunināšana',
  'label.comment_on_participant_improvement': 'Lūdzam paust viedokli par jaunieša veikumu',
  'note.edit_participant_review': 'Lai labotu šo informāciju, klikšķiniet uz pogas "Labot informāciju".',
  'errors.min_age': 'Minimālais vecums {age}',
  'notifications.assessor_link_expired': 'Novērtētāja reģistrācijas linka darbības termiņš ir iztecējis.',
  'label.secondary_email': 'Sekundārais e-pasts',
  'moduleTitle.review_participant_info': 'Caurskatīt informāciju par dalībnieku',
  'label.loading_payment_gateway': 'Notiek maksājuma vārtejas ielāde',
  'label.consent_given_login_as_child': 'Atļauja jau ir dota. Ielogojieties kā bērns.',
  'notifications.only_one_qualification_journey_per_award': 'Viena līmeņa ietvaros var tikt izveidots tikai viens ieskaites piedzīvojumu ceļojums.',
  'label.registration_fees_participant': 'Maksājums par reģistrēšanos - {name} (#{id})',
  'moduleTitle.leader_details': 'Informācija par Award vadītāju',
  'label.leader_name': 'Award vadītāja vārds',
  'label.leader_phone': 'Award vadītāja tālruņa numurs',
  'label.leader_email': 'Award vadītaja e-pasts',
  'moduleTitle.au_details': 'Informācija par Award vienību',
  'label.au_name': 'Award vienības nosaukums',
  'label.assessor_guidelines': 'Vadlīnijas',
  'label.assessor_cond_req': 'Pamatnosacījumi un prasības',
  'label.assessor_ref_handbook': 'Atsauce uz Award rokasgrāmatu',
  'label.assessor_ref_online_modules': 'Atsauce uz tiešsaistes apmācību moduli',
  'label.participant_has_no_aj_report': 'Dalībnieks pagaidām nav iesniedzis pārskatu',
  'moduleTitle.participant_details': 'Informācija par dalībnieku',
  'label.participants_has_no_logs': 'Dalībnieks pagaidām nav pievienojis ierakstus',
  'label.location_type': 'Atrašanās viedas veids',
  'label.activity_ready_for_signoff': 'Aktivitāte gatava gala apstiprināšanai.',
  'label.activities': 'Aktivitātes',
  'label.choose_how_you_want_to_login': 'Izvēlies to, kā vēlies ielogoties',
  'roles.leader': 'Vadītājs',
  'roles.award_verifier': 'Award apliecinātājs',
  'roles.coordinator': 'Vienības koordinators',
  'roles.aj_assessor': 'Piedzīvojumu ceļojuma novērtētājs',
  'roles.aj_supervisor': 'Piedzīvojumu ceļojuma uzraugs',
  'roles.instructor': 'Instruktors',
  'roles.nao_staff': 'Nacionālā operatora pārstāvis',
  'roles.super_user': 'Super-lietotājs',
  'roles.user': 'Lietotājs',
  'roles.viewer': 'Skatītājs',
  'roles.authorizing_contact': 'Pilnvarotā kontakpersona',
  'roles.if_staff_superuser': 'IF Staff Superuser',
  'roles.if_staff_statistical_user': 'IF Statistical User',
  'roles.if_staff_viewer': 'IF Staff Viewer',
  'roles.aj_instructor': 'P.C. instruktors',
  'label.if_you_have_questions_au': 'Ja tev ir kādi jautājumi par savu reģistrēšanos, lūdzam sazināties ar savu Award vadītāju',
  'label.we_will_send_you_an_email_leader': 'Mēs nosūtīsim tev e-pastu, tiklīdz tava TSG konta reģistrācija būs apstiprināta.',
  'moduleTitle.rejecting_assessor_invitation': 'Noraidīt uzaicinājumu kļūt par novērtētāju',
  'notifications.assessor_invitation_rejected': 'Aicinājums kļūt par novērtētāju ir noradīts',
  'moduleTitle.participants_list_is_empty': 'Dalībnieku saraksts ir tukšs',
  'label.note_from_participant': 'Ziņa no dalībnieka',
  'label.you_can_send_aj_to_leader': 'Tagad tu vari nosūtīt apstiprināšanai savu piedzīvojumu ceļojumu savam Award vadītājam',
  'button.save_report': 'Saglabāt pārskatu',
  'label.this_activity_has_no_assessor': 'Šai aktivitātei nav novērtētāja. Pirms sūti to apstiprināšanai, norādi informāciju par novērtētāju.',
  'label.activity_rejected_click_by_assessor': 'Tavs novērtētājs ir atgriezis tavu aktivitāti. Klikšķini, lai ',
  'button.reject': 'Noraidīt',
  'button.reject_invitation': 'Noraidīt ielūgumu',
  'label.reason': 'Iemesls',
  'label.accept_invitation_and_continue': 'Pieņemt ielūgumu un turpināt',
  'pageTitle.registration_reject': 'Reģistrācija atteikta',
  'errors.you_must_be_older_than_register_for_leader': 'Tev jābūt vismaz {years} gadiem un {months} mēnešiem, lai tev būtu iespēja reģistrēties kā Award vadītājam.',
  'label.your_report_approve_now_send_to_leader_without_note': 'Tavs ziņojums ir apstiprināts! Tagad tu vari iesniegt savu ziņojumu savam Award vadītājam. Zemāk tu vari pievienot ziņu.',
  'button.stop_assessing_this_activity': 'PĀRSTĀT ŠĪS AKTIVITĀTES VĒRTĒŠANU',
  'button.confirm': 'Apstiprināt',
  'moduleTitle.are_you_sure': 'Vai esi pārliecināts?',
  'label.content_restore': 'Saturs atjaunināts',
  'button.stop_editing': 'Beigt rediģēšanu',
  'notifications.activity_has_been_rejected': 'Aktivitāte ir noraidīta',
  'notifications.aj_has_been_rejected': 'Piedzīvojumu ceļojums ir noraidīts',
  'notifications.rp_has_been_rejected': 'Projekts ir noraidīts',
  'moduleTitle.additional_files': 'Papildu faili',
  'moduleTitle.no_additional_files': 'Papildu faili',
  'moduleTitle.stop_assessing_section': 'Beigt jomas vērtēšanu',
  'label.show_security_and_refund_policy': 'Parādīt drošības un samaksas atgriešanas politika',
  'moduleTitle.security_and_refund_policy': 'Drošības un samaksas atgriešanas politika',
  'label.fees_payment': 'Maksājuma veikšana',
  'label.redund_policy': 'Samaksas atgriešanas politika',
  'label.security_policy': 'Drošības politika',
  'label.leave_blank': 'Atstāt tukšu',
  'label.frequently_asked_questions': 'Biežāk uzdotie jautājumi',
  'label.language_selection_is_disabled_for_iac': 'Neatkarīgie Award centri nevar veikt valodas izvēli',
  'errors.min_nights_required': 'Ir vajadzīgas vismaz {nights} naktis',
  'label.completion_date': 'Pabeigšanas diena',
  'label.you_are_offline': 'Tu esi bezsaistē. Veiktās izmaiņas var netikt saglabātas.',
  'errors.start_date_after_award_start': 'Sākuma datums nevar būt pirms līmeņa uzsākšanas dienas.',
  'label.participants': 'Dalībnieki',
  'label.marketing_from_iaf': 'Izvēlies, lai saņemtu mārketinga materiālus no Starptautiskā Award fonda.',
  'label.marketing_from_oa': 'Izvēlies, lai saņemtu informatīvos un izdales materiālus no Izpildoperatora.',
  'label.marketing_from_nao': 'Izvēlies, lai saņemtu informatīvos un izdales materiālus no Nacionālā operatora.',
  'label.select_iac': 'Izvēlies Neatkarīgo Award centru',
  'label.you_will_be_redirected_to_the_paypal_payment': 'Klikšķini uz pogas "Maksāt", lai veiktu tiešsaistes maksājumu ar savu Visa, MasterCard kredītkarti, Visa debetkarti vai PayPal kontu.',
  'notifications.report_has_been_sent': 'Pārskats ir nosūtīts',
  'label.processing_paypal_payment': 'PayPal maksājuma apstrāde',
  'label.loading_paypal_gateway': 'Notiek PayPal vārtejas ielāde',
  'label.payment_failed': 'Maksājums nav noticis',
  'label.payment_has_been_cancelled': 'Maksājums ir atcelts vai nenoticis',
  'roles.naa_oa_staff': 'NAO darbinieks',
  'label.download_report_and_upload_signed_version': 'Lejupielādē pārskatu un augšupielādē parakstīto versiju',
  'button.download_summary_for_assessor': 'Lejupielādē kopsavilkumu priekš novērtētāja',
  'label.pay_online_mastercard': 'Maksāt tiešsaistē',
  'label.pay_online_paypal': 'Maksāt tiešsaistē',
  'notifications.authorization_code_is_missing': 'Trūkst autorizācijas kods',
  'errors.unknown_payment_error': 'Maksājuma laikā notika nezināma kļūme',
  'errors.already_in_use_by_auth_contact': 'Šo e-pastu jau izmanto autorizētais kontakts',
  'roles.if_staff_stat_user': 'IF Statistical User',
  'moduleTitle.you_have_been_logged_out_due_to_inactivity': 'Bezdarbības dēļ tu tiki izlogots',
  'announcement.survey_description.do_think_people_are_lazy': 'Vai, tavuprāt, jaunieši ir slinki? Lūdzam tevi izteikt savu viedokli, piedaloties starptautiskā aptaujā. Pastāsti mums ko TU domā par mūsdienu jauniešiem.',
  'announcement.survey_title.join_our_global_survey': 'Piedalies mūsu starptautiskajā aptaujā',
  'announcement.survey_button.if_below_25': 'Ja tev ir 16-25',
  'announcement.survey_button.if_over_25': 'Ja tev ir vairāk nekā 25',
  'moduleTitle.privacy_and_cookie_policy': 'Privātuma un sīkdatņu politika',
  'label.we_have_made_some_important_changes': 'Mēs esam ieviesuši būtiskas izmaiņas mūsu Privātuma un sīkdatņu politikā, un mēs vēlamies, lai tu zini kā tas ietekmēs tevi un tavus datus.',
  'button.i_agree': 'Es piekrītu',
  'button.see_more_details': 'Skatīt vairāk',
  'label.the_cookie_settings_on_this': 'Šīs mājaslapas sīkdatņu iestatījumi ir iestatīti uz &quot;atļaut sīkdatnes&quot; lai nodrošinātu tev iespējami labāku pārlūkošanas pieredzi. Ja turpināsi izmantot šo mājaslapu nemainot sīkdatņu iestatījumus vai izvēlēsies &quot;Piekrītu&quot;, tad tu piekrīti šim. ',
  'label.after_your_rp_describe': '',
  'label.you_are_going_to_be_logged_out': ''
}
